import React, { useEffect, useState } from "react";
import { RadioButton } from "primereact/radiobutton";
import { Dropdown } from "primereact/dropdown";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import cogoToast from "cogo-toast";
import api from "../../utils/api";
import APIConstant from "../../utils/constant";
import { CommonConfig } from "../../CommonConfig.js";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";

const GeneralConfiguration = () => {
  const [outwardMode, setSOutwardMode] = useState("");
  const [loading, setLoading] = useState(false);
  const [allowNegativeStock, setAllowNegativeStock] = useState(false);
  const [limitDays, setLimitDays] = useState("");
  const [selfMode, setSelfMode] = useState("");
  const [userId, setUserId] = useState("");
  const [configurationList, setConfigurationList] = useState([]);
  const [configurationId, setConfigurationId] = useState("");
  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    setUserId(data);
    getGeneralConfiguration(data);
  }, []);

  const getGeneralConfiguration = async () => {
    try {
      setLoading(true);
      let data = {
        CreatedBy: CommonConfig.loginData()?._id,
      };
      await api
        .post(APIConstant.path.GetOutwardMode, data)
        .then(async (response) => {
          if (response.Success) {
            setConfigurationList(response.Data);
            setSelfMode(response?.Data?.SelfMode);
            setSOutwardMode(response?.Data?.OutwardMode);
            setAllowNegativeStock(response?.Data?.AllowNegativeStock);
            setLimitDays(response?.Data?.LimitDays);
            setConfigurationId(response?.Data?._id);
            setLoading(false);
          } else {
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          cogoToast.error(err);
        });
    } catch (err) {
      setLoading(false);
      cogoToast.error(err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (outwardMode?.trim() && selfMode?.trim()) {
      let data = {
        OutwardMode: outwardMode,
        SelfMode: selfMode,
        AllowNegativeStock: allowNegativeStock,
        LimitDays: limitDays,
        CreatedBy: userId,
        UpdatedOn: Date.now(),
        id: configurationId ? configurationId : "",
      };
      try {
        api
          .post(APIConstant.path.AddUpdateOutwardMode, data)
          .then(async (response) => {
            if (response.Success) {
              setLoading(false);
              cogoToast.success(response?.Message);
              await getGeneralConfiguration();
            } else {
              setLoading(false);
              cogoToast.error(response?.Message);
            }
          })
          .catch((err) => {
            setLoading(false);
            cogoToast.error(err);
          });
      } catch (err) {
        setLoading(false);
        cogoToast.error(err);
      }
    } else {
      cogoToast.error("Please select both Outward and Self Mode");
      setLoading(false);
    }
  };

  const handleClear = () => {
    setSOutwardMode("");
    setSelfMode("");
  };

  return (
    <div className="p-4 flex justify-content-center">
      <Card title="General Configuration" className="w-25rem">
        <form onSubmit={handleSubmit}>
          <div style={{ display: "flex", gap: "80px", marginBottom: "20px" }}>
            {/* Outward Mode start */}
            <div>
              <h3
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  margin: "0 0 10px 0",
                }}
              >
                Outward Mode
              </h3>
              <div style={{ display: "flex", gap: "30px" }}>
                <div
                  className="field-radiobutton"
                  style={{ marginBottom: "8px" }}
                >
                  <RadioButton
                    inputId="Self"
                    name="outwardMode"
                    value="Self"
                    onChange={(e) => setSOutwardMode(e.value)}
                    checked={outwardMode === "Self"}
                  />
                  <label htmlFor="Self" style={{ marginLeft: "8px" }}>
                    Self
                  </label>
                </div>
                <div className="field-radiobutton mb-3">
                  <RadioButton
                    inputId="Sell"
                    name="outwardMode"
                    value="Sell"
                    onChange={(e) => setSOutwardMode(e.value)}
                    checked={outwardMode === "Sell"}
                  />
                  <label htmlFor="Sell" style={{ marginLeft: "8px" }}>
                    Sell
                  </label>
                </div>
              </div>
            </div>
            {/* Self mode Start */}
            <div>
              <h3
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  margin: "0 0 10px 0",
                }}
              >
                Self Mode
              </h3>
              <div style={{ display: "flex", gap: "30px" }}>
                <div className="field-radiobutton">
                  <RadioButton
                    inputId="Lifo"
                    name="selfMode"
                    value="Lifo"
                    onChange={(e) => setSelfMode(e.value)}
                    checked={selfMode === "Lifo"}
                  />
                  <label htmlFor="Lifo" style={{ marginLeft: "8px" }}>
                    LIFO
                  </label>
                </div>
                <div className="field-radiobutton">
                  <RadioButton
                    inputId="selfMode"
                    name="option"
                    value="Fifo"
                    onChange={(e) => setSelfMode(e.value)}
                    checked={selfMode === "Fifo"}
                  />
                  <label htmlFor="Fifo" style={{ marginLeft: "8px" }}>
                    FIFO
                  </label>
                </div>
                <div className="field-radiobutton">
                  <RadioButton
                    inputId="Average"
                    name="selfMode"
                    value="Average"
                    onChange={(e) => setSelfMode(e.value)}
                    checked={selfMode === "Average"}
                  />
                  <label htmlFor="Average" style={{ marginLeft: "8px" }}>
                    Average
                  </label>
                </div>
              </div>
            </div>

            <div>
              <label className="p-mr-2">Allow Negative Stock</label>
              <InputSwitch
                checked={allowNegativeStock}
                onChange={(e) => {
                  setAllowNegativeStock(e.value);
                }}
              />
            </div>
          </div>
          <div className="p-mb-2">
            <label className="p-mr-2">Limit Days</label>
            <InputText
              type="text"
              value={limitDays}
              onChange={(e) => {
                if (/^\d*$/i.test(e.target.value)) setLimitDays(e.target.value);
                else setLimitDays("");
              }}
              placeholder="Days"
              size="10"
              style={{ marginRight: 10 }}
            />
          </div>
          <Button
            type="submit"
            label={loading ? "Saving..." : "Save"}
            disabled={loading}
          />
          <Button
            type="button"
            label="Clear"
            className="w-full p-button-secondary"
            onClick={handleClear}
            style={{ marginLeft: "20px" }}
          />
        </form>
      </Card>
    </div>
  );
};

export default GeneralConfiguration;
